export default "__VITE_PUBLIC_ASSET__4e47372d__"